export default __webpack_public_path__ + "static/graphql@2x-83a575f58c4af41f19a911e5bd52efb9.png";